<div>
  <app-loader></app-loader>
  <router-outlet #outlet="outlet" />
</div>
